import moment from "moment";
const [DAY, WEEK, MONTH] = ["day", "week", "month"];

const pluralizeDuration = (duration = 1, durationType = DAY) => {
  if (duration > 1 || duration === 0) {
    return `${durationType}s`;
  }
  return durationType;
};

export class Dashboard {
  static getFormattedDate(date = undefined) {
    return moment(date).format("DD MMM YYYY");
  }

  static getRemainingDuration(date = undefined) {
    const now = moment();
    const futureDate = moment(date);
    let duration,
      durationType = DAY;

    duration = futureDate.diff(now, DAY);

    if (duration <= 0) {
      //just a safeguard against possible past dates from API
      duration = 0;
    } else if (duration >= 30) {
      duration = futureDate.diff(now, MONTH);
      durationType = MONTH;
    } else if (duration > 7) {
      duration = futureDate.diff(now, WEEK);
      durationType = WEEK;
    }

    return `${duration} ${pluralizeDuration(duration, durationType)}`;
  }
}
